// DevSaveConfirmModal.js — HITL confirmation avant écriture fichier

import React from 'react';
import { AlertTriangle } from 'lucide-react';
import './devCockpit.css';

export default function DevSaveConfirmModal({ path, onConfirm, onCancel, saving }) {
    if (!path) return null;

    return (
        <div className="dev-modal-overlay">
            <div className="dev-modal">
                <div style={{ display: 'flex', gap: 10, marginBottom: 14 }}>
                    <AlertTriangle size={20} color="#fbbf24" />
                    <h3>Confirmer l&apos;enregistrement</h3>
                </div>
                <p>
                    Enregistrer dans le sandbox isolé :
                </p>
                <code className="dev-modal__path">{path}</code>
                <div className="dev-modal__actions">
                    <button type="button" onClick={onCancel} disabled={saving} className="dev-btn">
                        Annuler
                    </button>
                    <button type="button" onClick={onConfirm} disabled={saving} className="dev-btn dev-btn--primary">
                        {saving ? 'Enregistrement…' : 'Enregistrer'}
                    </button>
                </div>
            </div>
        </div>
    );
}
